export default class TaskRepeatEndTypes {
  static DATE = "date";

  static OCCURRENCES = "occurrences";
}
